import { createAction, props } from '@ngrx/store';
import {
	ProcessingConfigModel,
	CreateProcessingConfigModel,
	UpdateProcessingConfigModel,
	MappingConfigModel,
	CreateMappingConfigModel,
	UpdateMappingConfigModel,
	ValidationConfigModel,
	CreateValidationConfigModel,
	UpdateValidationConfigModel,
	DuplicateConfigModel,
	CreateDuplicateConfigModel,
	UpdateDuplicateConfigModel,
	AggregationConfigModel,
	CreateAggregationConfigModel,
	UpdateAggregationConfigModel,
	ConversionConfigModel,
	CreateConversionConfigModel,
	UpdateConversionConfigModel,
	BaseSearchColumnFilterModel,
	FilterSearchRequest,
	SearchResponse,
	CustomerConfigSearchModel,
	CustomerConfigModel,
	CreateCustomerConfigModel,
	UpdateCustomerConfigModel,
	ListOptionModel
} from '@twrx-api-models';
import { IPreLoadModel } from 'app/models/dto/pre-load-model';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';

export enum ProcessingConfigActions {
	// Customer
	LoadCustomerConfigList = '[ProcessingConfig] LoadCustomerConfigList',
	CustomerConfigListLoaded = '[ProcessingConfig] CustomerConfigLoaded',

	PreLoadCustomerConfig = '[ProcessingConfig] PreLoadCustomerConfig',
	CustomerConfigPreLoaded = '[ProcessingConfig] CustomerConfigPreLoaded',
	PreLoadCustomerConfigNotFound = '[ProcessingConfig] PreLoadCustomerConfigNotFound',

	LoadCustomerConfigById = '[ProcessingConfig] LoadCustomerConfigById',
	CustomerConfigNotFound = '[ProcessingConfig] CustomerConfigNotFound',
	CustomerConfigByIdLoaded = '[ProcessingConfig] CustomerConfigByIdLoaded',

	CreateCustomerConfig = '[ProcessingConfig] CreateCustomerConfig',
	CustomerConfigCreated = '[ProcessingConfig] CustomerConfigCreated',

	UpdateCustomerConfig = '[ProcessingConfig] UpdateCustomerConfig',
	CustomerConfigUpdated = '[ProcessingConfig] CustomerConfigUpdated',

	DeleteCustomerConfig = '[ProcessingConfig] DeleteCustomerConfig',
	CustomerConfigDeleted = '[ProcessingConfig] CustomerConfigDeleted',

	LoadCustomerConfigOptions = '[ProcessingConfig] LoadCustomerConfigOptions',
	CustomerConfigOptionsLoaded = '[ProcessingConfig] CustomerConfigOptionsLoaded',

	// Processing
	LoadProcessingConfigByCustomerConfigId = '[ProcessingConfig] LoadProcessingConfigByCustomerConfigId',
	ProcessingConfigByCustomerConfigIdLoaded = '[ProcessingConfig] ProcessingConfigByCustomerConfigIdLoaded',

	CreateProcessingConfig = '[ProcessingConfig] CreateProcessingConfig',
	ProcessingConfigCreated = '[ProcessingConfig] ProcessingConfigCreated',

	UpdateProcessingConfig = '[ProcessingConfig] UpdateProcessingConfig',
	ProcessingConfigUpdated = '[ProcessingConfig] ProcessingConfigUpdated',

	DeleteProcessingConfig = '[ProcessingConfig] DeleteProcessingConfig',
	ProcessingConfigDeleted = '[ProcessingConfig] ProcessingConfigDeleted',

	// Mapping
	LoadMappingConfigByCustomerConfigId = '[ProcessingConfig] LoadMappingConfigByCustomerConfigId',
	MappingConfigByCustomerConfigIdLoaded = '[ProcessingConfig] MappingConfigByCustomerConfigIdLoaded',

	CreateMappingConfig = '[ProcessingConfig] CreateMappingConfig',
	MappingConfigCreated = '[ProcessingConfig] MappingConfigCreated',

	UpdateMappingConfig = '[ProcessingConfig] UpdateMappingConfig',
	MappingConfigUpdated = '[ProcessingConfig] MappingConfigUpdated',

	DeleteMappingConfig = '[ProcessingConfig] DeleteMappingConfig',
	MappingConfigDeleted = '[ProcessingConfig] MappingConfigDeleted',

	// Validation
	LoadValidationConfigByCustomerConfigId = '[ProcessingConfig] LoadValidationConfigByCustomerConfigId',
	ValidationConfigByCustomerConfigIdLoaded = '[ProcessingConfig] ValidationConfigByCustomerConfigIdLoaded',

	CreateValidationConfig = '[ProcessingConfig] CreateValidationConfig',
	ValidationConfigCreated = '[ProcessingConfig] ValidationConfigCreated',

	UpdateValidationConfig = '[ProcessingConfig] UpdateValidationConfig',
	ValidationConfigUpdated = '[ProcessingConfig] ValidationConfigUpdated',

	DeleteValidationConfig = '[ProcessingConfig] DeleteValidationConfig',
	ValidationConfigDeleted = '[ProcessingConfig] ValidationConfigDeleted',

	// Duplicate
	LoadDuplicateConfigByCustomerConfigId = '[ProcessingConfig] LoadDuplicateConfigByCustomerConfigId',
	DuplicateConfigByCustomerConfigIdLoaded = '[ProcessingConfig] DuplicateConfigByCustomerConfigIdLoaded',

	CreateDuplicateConfig = '[ProcessingConfig] CreateDuplicateConfig',
	DuplicateConfigCreated = '[ProcessingConfig] DuplicateConfigCreated',

	UpdateDuplicateConfig = '[ProcessingConfig] UpdateDuplicateConfig',
	DuplicateConfigUpdated = '[ProcessingConfig] DuplicateConfigUpdated',

	DeleteDuplicateConfig = '[ProcessingConfig] DeleteDuplicateConfig',
	DuplicateConfigDeleted = '[ProcessingConfig] DuplicateConfigDeleted',

	// Aggregation
	LoadAggregationConfigByCustomerConfigId = '[ProcessingConfig] LoadAggregationConfigByCustomerConfigId',
	AggregationConfigByCustomerConfigIdLoaded = '[ProcessingConfig] AggregationConfigByCustomerConfigIdLoaded',

	CreateAggregationConfig = '[ProcessingConfig] CreateAggregationConfig',
	AggregationConfigCreated = '[ProcessingConfig] AggregationConfigCreated',

	UpdateAggregationConfig = '[ProcessingConfig] UpdateAggregationConfig',
	AggregationConfigUpdated = '[ProcessingConfig] AggregationConfigUpdated',

	DeleteAggregationConfig = '[ProcessingConfig] DeleteAggregationConfig',
	AggregationConfigDeleted = '[ProcessingConfig] AggregationConfigDeleted',

	// Conversion
	LoadConversionConfigByCustomerConfigId = '[ProcessingConfig] LoadConversionConfigByCustomerConfigId',
	ConversionConfigByCustomerConfigIdLoaded = '[ProcessingConfig] ConversionConfigByCustomerConfigIdLoaded',

	CreateConversionConfig = '[ProcessingConfig] CreateConversionConfig',
	ConversionConfigCreated = '[ProcessingConfig] ConversionConfigCreated',

	UpdateConversionConfig = '[ProcessingConfig] UpdateConversionConfig',
	ConversionConfigUpdated = '[ProcessingConfig] ConversionConfigUpdated',

	DeleteConversionConfig = '[ProcessingConfig] DeleteConversionConfig',
	ConversionConfigDeleted = '[ProcessingConfig] ConversionConfigDeleted',

	ErrorOccurred = '[ProcessingConfig] ErrorOccurred'
}

// Customer
export const loadCustomerConfigList = createAction(
	ProcessingConfigActions.LoadCustomerConfigList,
	props<
		ActionRequestPayload<FilterSearchRequest<BaseSearchColumnFilterModel>>
	>()
);

export const customerConfigListLoaded = createAction(
	ProcessingConfigActions.CustomerConfigListLoaded,
	props<ActionResponsePayload<SearchResponse<CustomerConfigSearchModel>>>()
);

export const preLoadCustomerConfigById = createAction(
	ProcessingConfigActions.PreLoadCustomerConfig,
	props<ActionRequestPayload<IPreLoadModel<number>>>()
);

export const preLoadCustomerConfigNotFound = createAction(
	ProcessingConfigActions.PreLoadCustomerConfigNotFound
);

export const customerConfigByIdPreLoaded = createAction(
	ProcessingConfigActions.CustomerConfigPreLoaded,
	props<ActionResponsePayload<IPreLoadModel<CustomerConfigModel>>>()
);

export const loadCustomerConfigById = createAction(
	ProcessingConfigActions.LoadCustomerConfigById,
	props<ActionRequestPayload<number>>()
);

export const loadCustomerConfigNotFound = createAction(
	ProcessingConfigActions.CustomerConfigNotFound
);

export const customerConfigByIdLoaded = createAction(
	ProcessingConfigActions.CustomerConfigByIdLoaded,
	props<ActionResponsePayload<CustomerConfigModel>>()
);

export const createCustomerConfig = createAction(
	ProcessingConfigActions.CreateCustomerConfig,
	props<ActionRequestPayload<CreateCustomerConfigModel>>()
);

export const customerConfigCreated = createAction(
	ProcessingConfigActions.CustomerConfigCreated
);

export const updateCustomerConfig = createAction(
	ProcessingConfigActions.UpdateCustomerConfig,
	props<ActionRequestPayload<UpdateCustomerConfigModel>>()
);

export const customerConfigUpdated = createAction(
	ProcessingConfigActions.CustomerConfigUpdated
);

export const deleteCustomerConfig = createAction(
	ProcessingConfigActions.DeleteCustomerConfig,
	props<ActionRequestPayload<number>>()
);

export const customerConfigDeleted = createAction(
	ProcessingConfigActions.CustomerConfigDeleted
);

export const loadCustomerConfigOptions = createAction(
	ProcessingConfigActions.LoadCustomerConfigOptions,
	props<ActionRequestPayload<number>>()
);

export const customerConfigOptionsLoaded = createAction(
	ProcessingConfigActions.CustomerConfigOptionsLoaded,
	props<ActionResponsePayload<ListOptionModel<number>[]>>()
);

// Processing
export const loadProcessingConfigByCustomerConfigId = createAction(
	ProcessingConfigActions.LoadProcessingConfigByCustomerConfigId,
	props<ActionRequestPayload<number>>()
);

export const processingConfigByCustomerConfigIdLoaded = createAction(
	ProcessingConfigActions.ProcessingConfigByCustomerConfigIdLoaded,
	props<ActionResponsePayload<ProcessingConfigModel>>()
);

export const createProcessingConfig = createAction(
	ProcessingConfigActions.CreateProcessingConfig,
	props<ActionRequestPayload<CreateProcessingConfigModel>>()
);

export const processingConfigCreated = createAction(
	ProcessingConfigActions.ProcessingConfigCreated
);

export const updateProcessingConfig = createAction(
	ProcessingConfigActions.UpdateProcessingConfig,
	props<ActionRequestPayload<UpdateProcessingConfigModel>>()
);

export const processingConfigUpdated = createAction(
	ProcessingConfigActions.ProcessingConfigUpdated
);

export const deleteProcessingConfig = createAction(
	ProcessingConfigActions.DeleteProcessingConfig,
	props<ActionRequestPayload<number>>()
);

export const processingConfigDeleted = createAction(
	ProcessingConfigActions.ProcessingConfigDeleted
);

// Mapping
export const loadMappingConfigByCustomerConfigId = createAction(
	ProcessingConfigActions.LoadMappingConfigByCustomerConfigId,
	props<ActionRequestPayload<number>>()
);

export const mappingConfigByCustomerConfigIdLoaded = createAction(
	ProcessingConfigActions.MappingConfigByCustomerConfigIdLoaded,
	props<ActionResponsePayload<MappingConfigModel>>()
);

export const createMappingConfig = createAction(
	ProcessingConfigActions.CreateMappingConfig,
	props<ActionRequestPayload<CreateMappingConfigModel>>()
);

export const mappingConfigCreated = createAction(
	ProcessingConfigActions.MappingConfigCreated
);

export const updateMappingConfig = createAction(
	ProcessingConfigActions.UpdateMappingConfig,
	props<ActionRequestPayload<UpdateMappingConfigModel>>()
);

export const mappingConfigUpdated = createAction(
	ProcessingConfigActions.MappingConfigUpdated
);

export const deleteMappingConfig = createAction(
	ProcessingConfigActions.DeleteMappingConfig,
	props<ActionRequestPayload<number>>()
);

export const mappingConfigDeleted = createAction(
	ProcessingConfigActions.MappingConfigDeleted
);

// Validation
export const loadValidationConfigByCustomerConfigId = createAction(
	ProcessingConfigActions.LoadValidationConfigByCustomerConfigId,
	props<ActionRequestPayload<number>>()
);

export const validationConfigByCustomerConfigIdLoaded = createAction(
	ProcessingConfigActions.ValidationConfigByCustomerConfigIdLoaded,
	props<ActionResponsePayload<ValidationConfigModel>>()
);

export const createValidationConfig = createAction(
	ProcessingConfigActions.CreateValidationConfig,
	props<ActionRequestPayload<CreateValidationConfigModel>>()
);

export const validationConfigCreated = createAction(
	ProcessingConfigActions.ValidationConfigCreated
);

export const updateValidationConfig = createAction(
	ProcessingConfigActions.UpdateValidationConfig,
	props<ActionRequestPayload<UpdateValidationConfigModel>>()
);

export const validationConfigUpdated = createAction(
	ProcessingConfigActions.ValidationConfigUpdated
);

export const deleteValidationConfig = createAction(
	ProcessingConfigActions.DeleteValidationConfig,
	props<ActionRequestPayload<number>>()
);

export const validationConfigDeleted = createAction(
	ProcessingConfigActions.ValidationConfigDeleted
);

// Duplicate
export const loadDuplicateConfigByCustomerConfigId = createAction(
	ProcessingConfigActions.LoadDuplicateConfigByCustomerConfigId,
	props<ActionRequestPayload<number>>()
);

export const duplicateConfigByCustomerConfigIdLoaded = createAction(
	ProcessingConfigActions.DuplicateConfigByCustomerConfigIdLoaded,
	props<ActionResponsePayload<DuplicateConfigModel>>()
);

export const createDuplicateConfig = createAction(
	ProcessingConfigActions.CreateDuplicateConfig,
	props<ActionRequestPayload<CreateDuplicateConfigModel>>()
);

export const duplicateConfigCreated = createAction(
	ProcessingConfigActions.DuplicateConfigCreated
);

export const updateDuplicateConfig = createAction(
	ProcessingConfigActions.UpdateDuplicateConfig,
	props<ActionRequestPayload<UpdateDuplicateConfigModel>>()
);

export const duplicateConfigUpdated = createAction(
	ProcessingConfigActions.DuplicateConfigUpdated
);

export const deleteDuplicateConfig = createAction(
	ProcessingConfigActions.DeleteDuplicateConfig,
	props<ActionRequestPayload<number>>()
);

export const duplicateConfigDeleted = createAction(
	ProcessingConfigActions.DuplicateConfigDeleted
);

// Aggregation
export const loadAggregationConfigByCustomerConfigId = createAction(
	ProcessingConfigActions.LoadAggregationConfigByCustomerConfigId,
	props<ActionRequestPayload<number>>()
);

export const aggregationConfigByCustomerConfigIdLoaded = createAction(
	ProcessingConfigActions.AggregationConfigByCustomerConfigIdLoaded,
	props<ActionResponsePayload<AggregationConfigModel>>()
);

export const createAggregationConfig = createAction(
	ProcessingConfigActions.CreateAggregationConfig,
	props<ActionRequestPayload<CreateAggregationConfigModel>>()
);

export const aggregationConfigCreated = createAction(
	ProcessingConfigActions.AggregationConfigCreated
);

export const updateAggregationConfig = createAction(
	ProcessingConfigActions.UpdateAggregationConfig,
	props<ActionRequestPayload<UpdateAggregationConfigModel>>()
);

export const aggregationConfigUpdated = createAction(
	ProcessingConfigActions.AggregationConfigUpdated
);

export const deleteAggregationConfig = createAction(
	ProcessingConfigActions.DeleteAggregationConfig,
	props<ActionRequestPayload<number>>()
);

export const aggregationConfigDeleted = createAction(
	ProcessingConfigActions.AggregationConfigDeleted
);

// Conversion
export const loadConversionConfigByCustomerConfigId = createAction(
	ProcessingConfigActions.LoadConversionConfigByCustomerConfigId,
	props<ActionRequestPayload<number>>()
);

export const conversionConfigByCustomerConfigIdLoaded = createAction(
	ProcessingConfigActions.ConversionConfigByCustomerConfigIdLoaded,
	props<ActionResponsePayload<ConversionConfigModel>>()
);

export const createConversionConfig = createAction(
	ProcessingConfigActions.CreateConversionConfig,
	props<ActionRequestPayload<CreateConversionConfigModel>>()
);

export const conversionConfigCreated = createAction(
	ProcessingConfigActions.ConversionConfigCreated
);

export const updateConversionConfig = createAction(
	ProcessingConfigActions.UpdateConversionConfig,
	props<ActionRequestPayload<UpdateConversionConfigModel>>()
);

export const conversionConfigUpdated = createAction(
	ProcessingConfigActions.ConversionConfigUpdated
);

export const deleteConversionConfig = createAction(
	ProcessingConfigActions.DeleteConversionConfig,
	props<ActionRequestPayload<number>>()
);

export const conversionConfigDeleted = createAction(
	ProcessingConfigActions.ConversionConfigDeleted
);

export const errorOccurred = createAction(
	ProcessingConfigActions.ErrorOccurred
);
